module.exports = __webpack_public_path__ + "static/img/contact-bottom-whatsapp.03078ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/header/contact-bottom-whatsapp.png
// module id = Lo7V
// module chunks = 1 2